import RequestCache from "./RequestCache";

export default class AnketaQuestions extends RequestCache {
    get link() {
        return this.links.anketaQuestions;
    }

    get cacheInterval() {
        return 7;
    }

}
